export default "__VITE_ASSET__BBeB63Q5__"